import React from 'react';

import SocialLinks from '../global/SocialLinks';
import HSSLogo from '../../assets/hss_logo_black_final.svg';
import NEHLogo from './assets/neh.svg';
import MapPin from '../../assets/map-pin.png';

import style from './AboutSidebar.module.scss';

const AboutSidebar = props => {
  // console.log(props.settingsContent);
  return (
    <div className={`${style.aboutSidebar} ${props.show ? style.loaded : ''}`}>
      <div className={style.link}>
        <a href={props.settingsContent.credits_pdf_file[0].url} target="_blank">
          {props.settingsContent.credits_pdf_link_text}
        </a>
      </div>
      <h4>Visit the Exhibition in Person</h4>
      <div className={style.address}>
        <p>265 Henry Street</p>
        <p>New York, NY 10002</p>
      </div>
      <div className={style.hours}>
        <p>Hours:</p>
        {props.settingsContent.hours.map((data, i) => (
          <div key={`day${i}`}>
            <p>
              {data.days} • {data.open_time}-{data.close_time}
            </p>
          </div>
        ))}
        {props.settingsContent.weekend_hours && (
          <div className={style.weekend}>
            <a
              href={props.settingsContent.weekend_hours.url}
              target={props.settingsContent.weekend_hours.target}
            >
              {props.settingsContent.weekend_hours.title}
            </a>
          </div>
        )}
      </div>
      <div className={style.socialWrapper}>
        <SocialLinks noPad redIcons data={props.settingsContent.social} />
      </div>
      <a
        href="https://goo.gl/maps/Qau5zPdXRJ12"
        target="_blank"
        className={style.directions}
      >
        <img src={MapPin} alt="Map Pin Icon" className={style.mapPin} />
        <div className={style.directionsText}>Get Directions</div>
      </a>
      <div>
        <img
          src={NEHLogo}
          alt="National Endowment for the Humanities"
          className={style.nehLogo}
        />
        <p className={style.greyText}>
          The House on Henry Street is made possible, in part, by a major grant
          from the National Endowment for the Humanities: Exploring the human
          endeavor
        </p>
      </div>
    </div>
  );
};

export default AboutSidebar;



// WEBPACK FOOTER //
// ./src/components/basic/AboutSidebar.js